<template>
  <div class="product-details-content-setup-step-04">
    <div class="mb-5">
      <step-title
        title="Certificado"
        description="Configure e personalize o certificado do seu curso."
        icon="fa fa-award"
      />
    </div>

    <div class="row">
      <div class="col-xl-8 mt-6">
        <certificate-preview
          :courseName="form.name_course"
          :hourly_load="form.hourly_load"
          :organizer_name="form.organizer_name"
          :image_signature="form.image_signature"
          :color_1="form.metadata_certification.color_1"
          :color_2="form.metadata_certification.color_2"
          :typography="form.metadata_certification.typography"
          :template="form.certificate_background_image"
          :textColor="form.metadata_certification.text_color"
          :signature_typography="
            form.metadata_certification.signature_typography
          "
        />
        <div class="small text-secondary mt-5">
          Certificado com dimensão A4 ( 297 x 210 ).
        </div>
      </div>
      <div class="col-xl-4 mt-6">
        <b-tabs content-class="mt-5" fill>
          <b-tab title="Texto" active>
            <form-group
              select
              v-model="form.metadata_certification.typography"
              id="typography"
              label="Tipografia"
              :options="typography"
            />
            <form-group
              v-model="form.name_course"
              id="name_course"
              label="Nome do curso"
              placeholder="Ex.: Curso de Marketing"
              :errors="errors.name_course"
              :required="form.certificate_enabled"
            />
            <form-group
              v-model="form.hourly_load"
              id="hourly_load"
              label="Carga horária"
              placeholder="Ex.: 30"
              mask="#####"
              :errors="errors.hourly_load"
              :required="form.certificate_enabled"
            />
          </b-tab>
          <b-tab title="Assinatura">
            <div class="small text-secondary text-center" v-if="!useSignature">
              Caso não seja adicionada uma assinatura, o nome do organizador
              será usado no lugar.
            </div>
            <bp-input
              v-model="form.organizer_name"
              id="organizer_name"
              label="Nome do organizador"
              placeholder="Ex.: Blitzpay"
              :errors="errors.organizer_name"
              :required="form.certificate_enabled"
              :limit="85"
              lock
            />
            <small class="text-secondary">
              Esse nome aparecerá abaixo do campo de assinatura.
            </small>
            <form-group
              select
              label="Tipografia (assinatura)"
              id="signature-typography"
              v-if="!useSignature"
              :options="signatureTypography"
              v-model="form.metadata_certification.signature_typography"
              placeholder="Escolha uma tipografia"
            />
            <hr />
            <b-form-checkbox switch class="my-5" v-model="useSignature">
              Adicionar assinatura
            </b-form-checkbox>
            <input-image
              v-if="useSignature"
              id="image-signature"
              v-model="form.image_signature"
              title="Imagem da assinatura"
              description="A assinatura será inserida acima do nome do organizador"
            />
          </b-tab>
          <b-tab title="Personalizar">
            <div v-if="!customBackground">
              <div class="text-center">
                <small class="text-secondary d-block">
                  Por padrão, utilizamos as cores selecionadas abaixo.
                </small>
                <small class="mt-3 text-secondary d-block">
                  Se preferir, escolha as cores de sua preferência.
                </small>
              </div>
              <div class="row mt-3 px-lg-3">
                <div class="col-lg-6 px-lg-3">
                  <form-group
                    v-model="form.metadata_certification.color_1"
                    id="color1"
                    label=""
                    color
                  />
                </div>
                <div class="col-lg-6 px-lg-3">
                  <form-group
                    v-model="form.metadata_certification.color_2"
                    id="color2"
                    label=""
                    color
                  />
                </div>
                <div class="col-lg-12 px-lg-3">
                  <form-group
                    v-model="form.metadata_certification.text_color"
                    class="text-color"
                    id="text_color"
                    label="Cor do texto"
                    color
                  />
                </div>
              </div>
              <button
                type="button"
                class="mt-5 btn btn-block btn-outline-secondary"
                @click="resetColor"
              >
                Voltar a cor padrão
              </button>
              <hr class="my-5" />
            </div>
            <div class="text-center small text-secondary">
              Ou você pode adicionar uma imagem para ser usada como um template.
            </div>
            <b-form-checkbox
              switch
              v-model="customBackground"
              class="mt-5"
              id="add-template"
            >
              Adicionar um template
            </b-form-checkbox>
            <div
              v-if="customBackground"
              class="d-flex flex-column justify-content-center mt-3"
            >
              <input-image
                id="certificate-background-image"
                v-model="form.certificate_background_image"
                title="Imagem do template"
                dimensions="877x620px, 1754x1240px, 3508x2480px"
                description="Escolha uma imagem com a resolução adequada a uma folha A4."
              />
              <div class="col-lg-12 px-lg-3">
                <form-group
                  v-model="form.metadata_certification.text_color"
                  id="text-color"
                  class="text-color"
                  label="Cor do texto"
                  color
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import CertificatePreview from "./CertificatePreview.vue";

export default {
  components: { CertificatePreview },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    typography: {
      type: Array,
      default: () => [
        { id: "Poppins", name: "Poppins" },
        { id: "Bellota", name: "Bellota" },
        { id: "Great Vibes", name: "Great Vibes" },
        { id: "Poiret One", name: "Poiret One" },
        { id: "Parisienne", name: "Parisienne" },
        { id: "Simonetta", name: "Simonetta" },
        { id: "Voces", name: "Voces" }
      ]
    }
  },
  data() {
    return {
      customBackground: !!this.form.certificate_background_image,
      useSignature: !!this.form.image_signature,
      imageSignature: this.form.image_signature,
      signatureTypography: [
        { id: "", name: "Padrão" },
        { id: "Whisper", name: "Whisper" },
        { id: "Allison", name: "Allison" },
        { id: "Ms Madi", name: "Ms Madi" }
      ]
    };
  },
  components: {
    CertificatePreview
  },
  methods: {
    resetColor() {
      this.form.metadata_certification.color_1 = "#2E0A5D";
      this.form.metadata_certification.color_2 = "#AD3E9B";
      this.form.metadata_certification.text_color = "#6E6E6E";
    }
  },
  watch: {
    customBackground(v) {
      if (!v) this.form.certificate_background_image = null;
    },
    useSignature(v) {
      if (!v) this.form.image_signature = null;
      else this.form.image_signature = this.imageSignature;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-details-content-setup-step-04 {
  ::v-deep button.color-button {
    top: 23px;
    min-height: 20px;
    min-width: 20px;
  }

  ::v-deep .form-group #color1 #color2 {
    padding: 0px;
  }

  ::v-deep .form-control,
  #color1 {
    font-size: 13px;
  }

  ::v-deep .form-group .color-picker {
    padding-top: 10px;
  }

  ::v-deep .vc-chrome {
    font-family: unset;
  }

  ::v-deep .vc-chrome-fields-wrap {
    display: none !important;
  }

  ::v-deep .vc-chrome-alpha-wrap {
    display: none !important;
  }

  ::v-deep .vc-chrome-color-wrap {
    display: none !important;
  }
  ::v-deep .nav-link {
    padding: 3.4px;
    margin-bottom: -1px;
    &.active {
      font-size: 15px;
    }
    &:hover,
    &:focus {
      font-size: 15px;
    }
  }
  .text-color {
    ::v-deep button.color-button {
      top: 54px;
    }
  }
}
</style>
